import React from 'react'
import Ikeja from '../components/Ikeja'

const ThingsToDoPage = () => {
  return (
    <div className='md:pt-[140px] pt-[100px]'>
      <Ikeja location="ABUJA" />
      <Ikeja location="LAGOS" />
      <Ikeja location="OGUN" />
    </div>
  )
}

export default ThingsToDoPage